import { SVGProps } from "react";

const IconIntegration = (props: SVGProps<SVGSVGElement>) => {
    const { className, ...rest } = props;

    return (
        <svg
            className={className}
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden
            {...rest}
        >
            <path
                d="M8.64258 12.2444C8.79797 12.4901 8.98607 12.7278 9.19053 12.9417C10.5236 14.2888 12.5437 14.5107 14.0976 13.5677C14.3838 13.3934 14.6456 13.1953 14.8991 12.9417L18.4649 9.32836C20.0351 7.73563 20.0351 5.14446 18.4649 3.55173C16.8946 1.95899 14.3266 1.95899 12.7563 3.55173L11.9712 4.34413"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            <path
                d="M10.0288 17.6548L9.24367 18.4477C7.67341 20.0413 5.10538 20.0413 3.53512 18.4477C1.96486 16.854 1.96486 14.2614 3.53512 12.6678L7.10092 9.0524C8.67118 7.45877 11.2228 7.45877 12.8095 9.0524C13.0221 9.26647 13.202 9.50432 13.3574 9.75011"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
        </svg>
    );
};

export default IconIntegration;
